import { DateTime } from 'luxon';
import z from 'zod';

export const isValidIsoDate = (value: string): boolean => {
  const parsedDate = DateTime.fromISO(value, { zone: 'utc' });
  return parsedDate.isValid && parsedDate.toISODate() === value;
};

export const isoDateSchema = z.string().refine(isValidIsoDate, {
  message: 'Date must use YYYY-MM-DD',
});
